import { Route, Routes } from "react-router-dom";
import BillingPage from "./components/Billing";
import SettingsHome from "./components/Home";
import UserInformation from "./components/User/UserInformation";
import { IntakeQuestionProvider } from "../../contexts/IntakeQuestionContext";
import SecurityInformation from "./components/Security/SecurityInformation";
import IntegrationsPage from "./components/Integrations/IntegrationsPage";

export default function SettingsPage() {
  return (
    <IntakeQuestionProvider>
      <Routes>
        <Route path="/" element={<SettingsHome />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/security" element={<SecurityInformation />} />
        <Route path="/user" element={<UserInformation />} />
        <Route path="/integrations/*" element={<IntegrationsPage />} />
      </Routes>
    </IntakeQuestionProvider>
  );
}
